class DestroyTilingCommand {
  constructor(receiver, controller) {
    this.receiver = receiver;
    this.controller = controller;
  }
  execute() {
    this.controller.destroyTiling(this.receiver);
  }
  undo() {
    this.controller.createTilingFromObject(this.receiver.getOriginalObject());
  }
}

export default DestroyTilingCommand;
